import { CompanyBenefit } from 'types/generatedSchemaTypes';
import { create } from 'zustand';

type BenefitState = {
  benefit: CompanyBenefit | undefined;
  prefillEmail: string;
};

type BenefitActions = {
  setSelectedBenefit: (benefit: CompanyBenefit) => void;
  setPrefillEmail: (email: string) => void;
};

export const useBenefitStore = create<BenefitState & BenefitActions>((set) => ({
  benefit: undefined,
  prefillEmail: '',
  setSelectedBenefit: (benefit) => set({ benefit: benefit }),
  setPrefillEmail: (email) => set({ prefillEmail: email }),
}));
